import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { acceptApplication, cancelApplication, openDialog } from "../../../store/actions";

interface IProps {
  id: number;
  header: string;
  allowed: boolean;
  elementRef: any;
}

const mapDispatchToProps = (dispatch: any) => ({
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions)),
  acceptApplicationDispatch: (governorateId: number) => dispatch(acceptApplication(governorateId)),
  cancelApplicationDispatch: (governorateId: number) => dispatch(cancelApplication(governorateId))
})
const connector = connect(null, mapDispatchToProps);

const ApplicationActions = ({
  id,
  header,
  allowed,
  elementRef,
  openDialogDispatch,
  acceptApplicationDispatch,
  cancelApplicationDispatch
}: IProps & ConnectedProps<typeof connector>) => (
  <table className="table">
    <tr>
      <td className="no-border">
        <a
          href="#"
          onClick={() => openDialogDispatch({
            name: "ConfirmDialog",
            header: "Reject application",
            clear: true,
            question: "Do you want to reject the application?",
            cancel: "Back",
            cancelAction: () => openDialogDispatch({
              name: "ApplicationActions",
              clear: true,
              header,
              id,
              allowed,
              elementRef
            }),
            confirm: "Reject",
            confirmAction: () => cancelApplicationDispatch(id),
            elementRef
          })}
          className="btn btn-blank btn-no-width"
        >
          Reject application
        </a>
      </td>
    </tr>
    <tr>
      <td className="no-border">
        <a
          href="#"
          onClick={() => allowed && openDialogDispatch({
            name: "ConfirmDialog",
            header: "Accept application",
            clear: true,
            question: "Do you want to accept the application?",
            cancel: "Back",
            cancelAction: () => openDialogDispatch({
              name: "ApplicationActions",
              clear: true,
              header,
              id,
              allowed,
              elementRef
            }),
            confirm: "Accept",
            confirmAction: () => allowed && acceptApplicationDispatch(id),
            elementRef
          })}
          className={`btn btn-blank btn-no-width ${allowed ? "" : "disabled"}`}
        >
          Accept application
        </a>
      </td>
    </tr>
  </table>
)

export default connector(ApplicationActions);
